import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

const WS_BASE = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");

export default function useRideTracking(tripId, enabled = true) {
  const [trip, setTrip] = useState(undefined);
  const [mode, setMode] = useState("connecting");
  const timers = useRef({});
  const refresh = () => tripId && api.get(`/ride-demo/trips/${tripId}/tracking`).then(({ data }) => setTrip(data.trip)).catch(() => {});

  useEffect(() => {
    if (!enabled || !tripId) return undefined;
    let ws, closed = false;
    const t = timers.current;
    const poll = () => api.get(`/ride-demo/trips/${tripId}/tracking`).then(({ data }) => setTrip(data.trip)).catch(() => {});
    const startPolling = () => {
      setMode("polling");
      poll();
      clearInterval(t.poll);
      t.poll = setInterval(poll, 8000);
      clearTimeout(t.retry);
      t.retry = setTimeout(connect, 30000);
    };
    async function connect() {
      if (closed) return;
      let ticket;
      try { ({ data: { ticket } } = await api.post(`/ride-demo/trips/${tripId}/ws-ticket`)); } catch { startPolling(); return; }
      if (closed) return;
      try { ws = new WebSocket(`${WS_BASE}/api/bo/ride-demo/ws/trips/${tripId}?ticket=${encodeURIComponent(ticket)}`); } catch { startPolling(); return; }
      ws.onopen = () => { setMode("live"); clearInterval(t.poll); clearInterval(t.ping);
        t.ping = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000); };
      ws.onmessage = (e) => { try { const msg = JSON.parse(e.data); if (msg.type === "trip") setTrip(msg.trip); } catch { /* ignore */ } };
      ws.onclose = () => { clearInterval(t.ping); if (!closed) startPolling(); };
    }
    connect();
    return () => { closed = true; ws?.close(); Object.values(t).forEach((x) => { clearInterval(x); clearTimeout(x); }); };
  }, [tripId, enabled]);

  return { trip, mode, refresh };
}
